/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_Email_TitleInputs */

const en_contact_email_title = /** @type {(inputs: Contact_Email_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Email`)
};

const ko_contact_email_title = /** @type {(inputs: Contact_Email_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`이메일`)
};

const ja_contact_email_title = /** @type {(inputs: Contact_Email_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`メール`)
};

/**
* | output |
* | --- |
* | "Email" |
*
* @param {Contact_Email_TitleInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const contact_email_title = /** @type {((inputs?: Contact_Email_TitleInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_Email_TitleInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_contact_email_title(inputs)
	if (locale === "ko") return ko_contact_email_title(inputs)
	return ja_contact_email_title(inputs)
});